import type { ThemePresetColor } from "@/services/theme";

export const LIST_LAZY_DEFAULT_SCROLL_THRESHOLD = 10;

export const LIST_PARAMS_PREVIEW_COLOR: ThemePresetColor = "geekblue";
